import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { Checkbox } from "@mui/material";
import "./Field.scss";

const CheckMultiSelectField = (props: any) => {
  return (
    <FormControl style={{ width: "100%", marginTop: "7px" }}>
      <Select
        labelId="demo-multiple-chip-label"
        id="demo-multiple-chip"
        className="multiple-select-chip"
        multiple
        fullWidth
        value={props.value || []}
        onChange={props.onChange}
        input={<OutlinedInput id="select-multiple-chip" />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((value: any) => (
              <Chip
                className="bg-lite"
                key={value}
                label={
                  props.options.find((option: any) => option.value === value)
                    ?.label
                }
                style={{ color: "white" }}
              />
            ))}
          </Box>
        )}
      >
        {props.options?.map((name: any) => (
          <MenuItem key={name.value} value={name.value}>
            <Checkbox
              className="color-sec"
              checked={props?.value?.indexOf(name?.value) > -1}
            />
            {name.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CheckMultiSelectField;
